import React from "react";
import { siteData } from "../data/mock";
import { Mail, MessageCircle, Phone } from "lucide-react";

const BrandLogoLarge = () => (
  <a href="#" className="flex items-center gap-2">
    <img
      src="https://customer-assets.emergentagent.com/job_career-ai-summit-1/artifacts/xp67b1sj_image.png"
      alt="Epsilon Executive Education"
      className="h-11 w-auto"
    />
  </a>
);

const Footer = () => {
  const { footer } = siteData;
  const waDigits = (footer.phone || "").replace(/\D/g, "");
  const waUrl = waDigits
    ? `https://wa.me/${waDigits}?text=${encodeURIComponent(
        "Hi Epsilon, I'd like to know more about The AI Career Accelerator webinar."
      )}`
    : "#";
  return (
    <footer className="pt-14 sm:pt-20 pb-8 border-t hairline">
      <div className="max-w-[1280px] mx-auto px-5 sm:px-6 lg:px-10">
        <div className="grid md:grid-cols-2 gap-10 sm:gap-12">
          <div>
            <BrandLogoLarge />
            <p className="text-slate-400 text-[14px] leading-relaxed mt-6 max-w-[420px]">
              {footer.about}
            </p>
          </div>
          <div>
            <div className="flex items-center gap-3">
              <span className="eyebrow-line" />
              <span className="text-[11px] tracking-[0.32em] uppercase text-[#5EC7F5]">
                {footer.reachTitle}
              </span>
            </div>
            <div className="mt-6 space-y-4">
              <a
                href={`mailto:${footer.email}`}
                data-testid="footer-email-link"
                className="flex items-center gap-3 text-slate-300 hover:text-white transition-colors"
              >
                <Mail className="w-4 h-4 text-[#5EC7F5]" />
                <span className="text-[14px]">{footer.email}</span>
              </a>
              <a
                href={waUrl}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-whatsapp-link"
                className="flex items-center gap-3 text-slate-300 hover:text-white transition-colors"
              >
                <MessageCircle className="w-4 h-4 text-[#5EC7F5]" />
                <span className="text-[14px]">{footer.whatsapp}</span>
              </a>
              <a
                href={`tel:${footer.phone.replace(/\s/g, "")}`}
                data-testid="footer-phone-link"
                className="flex items-center gap-3 text-slate-300 hover:text-white transition-colors"
              >
                <Phone className="w-4 h-4 text-[#5EC7F5]" />
                <span className="text-[14px]">{footer.phone}</span>
              </a>
            </div>
          </div>
        </div>

        <div className="mt-14 h-px divider-line" />
        <p className="text-center text-slate-500 text-[12px] mt-6">
          {footer.copyright}
        </p>
      </div>
    </footer>
  );
};

export default Footer;
